<template>
   <el-drawer
    id="contract-page"
    v-model="drawer"
    :title="contractTitle"
    direction="rtl" 
    :before-close="handleClose"  
    size="100%" 
  >
    <span class="contract-text" v-html="contractText"></span>
  </el-drawer>
  <!-- <div id="contract-page" >
    <div class="container">
      <span v-html="contractText"></span>
    </div> 
  </div> -->
</template>

<script setup lang="ts">
import { ref, reactive, onMounted ,getCurrentInstance} from 'vue';
import { useRoute } from 'vue-router'

const drawer = ref(false)
const currentInstance = getCurrentInstance()
const { $api } = currentInstance!.appContext.config.globalProperties
const contractTitle=ref();
const contractText=ref();
const route = useRoute()


const getContract=(status:number)=>{
  let url="";
  switch(status){
    case 1:
      contractTitle.value="用户协议"
      url=import.meta.env.VITE_BASE_URL_API+"/company/getUserAgreement";
      break;
    case 2:
      contractTitle.value="隐私协议"
    url=import.meta.env.VITE_BASE_URL_API+"/company/getPrivacyAgreement";
      break;
    case 3:
      contractTitle.value="付费协议"
    url=import.meta.env.VITE_BASE_URL_API+"/company/getPayAgreement";
      break;
    
  }
  $api({
      url: url,
      method: 'GET',
      withCredentials: false,
    }).then(async (res: { data: any; }) => {
      console.log(res)
      contractText.value=res.data.data;
    })
    .catch((e: any) => {
      console.log(e)
    })
}
const openDrawer=(status:number)=>{
  drawer.value=true;
  getContract(status);
}
const handleClose=()=>{
  contractText.value="";
  contractTitle.value="";
  drawer.value=false;
}
// onMounted(()=>{
//   getContract();
// })
defineExpose({ openDrawer });
</script>

<style  lang="scss">
#contract-page{ 
  white-space: pre-line;
  .contract-text{
    background:#ffffff;
    text-align: left !important;
  }
  .el-drawer__body{
    text-align: left;
  }
  .el-drawer__header{
    margin-bottom: 0;
    padding-bottom: 10px;
    padding-top:10px;
    border-bottom: 1px solid #bfbfbf;
  }
  .el-drawer__title{
    text-align: center;
  }
}
</style>